/**
 * Event emitter for crypto/trust related events
 * Provides centralized event handling for device trust operations
 */

import { EventEmitter } from 'events';

// Event names
export const TrustEvents = {
  BOOTSTRAP_START: 'trust/bootstrap:start',
  BOOTSTRAP_DONE: 'trust/bootstrap:done',
  BOOTSTRAP_ERROR: 'trust/bootstrap:error',

  DEVICE_TRUSTING: 'trust/device:trusting',
  DEVICE_TRUSTED: 'trust/device:trusted',
  DEVICE_UNCHANGED: 'trust/device:unchanged',
  DEVICE_ERROR: 'trust/device:error',

  VERIFICATION_START: 'trust/verification:start',
  VERIFICATION_COMPLETE: 'trust/verification:complete',
  VERIFICATION_CANCEL: 'trust/verification:cancel',
  VERIFICATION_ERROR: 'trust/verification:error',
};

// Error codes
export const DeviceTrustError = {
  NETWORK: 'NETWORK_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED',
  NO_CROSS_SIGNING: 'NO_CROSS_SIGNING',
  NO_CRYPTO: 'NO_CRYPTO_AVAILABLE',
  TIMEOUT: 'OPERATION_TIMEOUT',
  ALREADY_VERIFIED: 'ALREADY_VERIFIED',
  UNKNOWN: 'UNKNOWN_ERROR',
};

class TrustEventEmitter extends EventEmitter {
  constructor() {
    super();
    this.setMaxListeners(20); // Allow multiple components to listen
  }

  /**
   * Emit a trust event with payload
   * @param {string} event - Event name from TrustEvents
   * @param {Object} payload - Event data
   */
  emitTrustEvent(event, payload) {
    this.emit(event, {
      ...payload,
      timestamp: Date.now(),
    });
  }
}

// Singleton instance
export const trustEventEmitter = new TrustEventEmitter();